import InaccuracyReport from './InaccuracyReport';

export default InaccuracyReport;



// WEBPACK FOOTER //
// ./src/components/Building/InaccuracyReport/index.js